<template>
  <div class="tag-wrapper" @click="$emit('click')">
    <TNTag v-bind="$attrs" v-on="$listeners" :class="{ 'tag--dark': isDark }">
      <span :class="{ 'tag__text--dark': isDark }">{{ text }}</span>
    </TNTag>
  </div>
</template>

<script>
import * as TNTag from '@thinknimble/tag'
export default {
  name: 'Tag',
  components: { TNTag },
  data() {
    return {}
  },
  props: {
    text: {
      type: [String, Number],
    },
  },
  computed: {
    isDark() {
      return this.$attrs.hasOwnProperty('dark')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/fontstyles';
.tag-wrapper {
  display: flex;
}
::v-deep .tag {
  background-color: $gold;
  border-radius: 1px;
  &--dark {
    background-color: $coal;
  }

  &__inner {
    height: 1.5rem;
  }
  &__text {
    white-space: nowrap;
    @include tag-font();
    @include breakpoint(768px, 'max') {
      font-size: 12px;
    }

    padding: 0.1rem 0.8rem;
    &--dark {
      color: $white;
    }
  }
}
</style>
